import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import * as blob from 'blobjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewChild } from '@angular/core';
import { MatButton } from '@angular/material';
import { DroppedFile,ReadMode } from 'angular-file-dropzone';
@Component({
  selector: 'app-faktur-pajak-keluaran',
  templateUrl: './faktur-pajak-keluaran.component.html',
  styleUrls: ['./faktur-pajak-keluaran.component.css']
})
export class FakturPajakKeluaranComponent implements OnInit {
  droppedFile: DroppedFile;
  filename: String;
  size: String;
  readMode = ReadMode.binaryString;
  @ViewChild ('convertButton') convertButton: MatButton;

  constructor(public snackbar: MatSnackBar) {
  }

  ngOnInit() {
    // this.convertButton.disabled = true;
  }

  downloadExcelFile() {
    window.location.href='https://firebasestorage.googleapis.com/v0/b/efaktur-75f43.appspot.com/o/public%2FFK_TEMPLATE_XLS.xlsx?alt=media&token=a2b2b056-6842-4642-9c8b-41bc79a65ad4';
  }
  fileDrop(e: DroppedFile) {
    console.log(e.content);
    this.droppedFile = e;
    const rABS = true;
    const reader = new FileReader();
    const wb = XLSX.read(e.content, {type: 'binary'});
    const dataSheet = wb.Sheets['data'];
    this.size = e.size.toString();
    this.filename = e.name;
    console.log(dataSheet);
  }

  // dropped(event: UploadEvent) {
  //  event.files.forEach(f => {
  //    console.log(f.fileEntry.resultFile);
  //  });
    // if (event.files.length > 0) {
    //   const f = event.files[0];
    //   const rABS = true;
    //   if (f.fileEntry.isFile) {
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       let data = reader.result;
    //       if (!rABS) {
    //         data = new Uint8Array(reader.result);
    //       }
    //       const wb = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
    //     };
    //     if (rABS) {
    //       reader.readAsBinaryString(f.fileEntry.file);
    //     } else {
    //       reader.readAsArrayBuffer(f.fileEntry.file);
    //     }
    //   }

    //   if (f.fileEntry.isDirectory) {
    //   }

      // if ( f.fileEntry.resultFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      //   || f.fileEntry.resultFile.type === 'application/vnd.oasis.opendocument.spreadsheet') {
      //   this.uploadedFile = f;
      //   this.toggleConvertButton();
      //   console.log(f.fileEntry);
      // } else {
      //   this.uploadedFile = null;
      //   this.snackbar.open('Tipe File yang ditaruh salah', null, {duration : 1000});
      //   this.toggleConvertButton();
      // }
    //}
    // for (const file of event.files){
    //   console.log(file.fileEntry);
    //   console.log(file.fileEntry.resultFile.slice());
    //   // file.fileEntry.file(info => {
    //   //  console.log(info);
    //   // });
    // }
//  }

  // toggleConvertButton() {
  //   if (this.uploadedFile != null) {
  //     this.convertButton.disabled = false;
  //   } else {
  //     this.convertButton.disabled = true;
  //   }
  // }

  // save() {
  //   if (this.uploadedFile != null) {
  //     const excelBlob: Blob = this.uploadedFile.fileEntry.resultFile.slice();
  //     const workbook = XLSX.read(excelBlob, {type: 'buffer'});
  //     const data = workbook.Sheets['data'];
  //     console.log(workbook.SheetNames);
  //     if (data != null) {
  //       FileSaver.saveAs(excelBlob, this.uploadedFile.fileEntry.name);
  //     } else {
  //       this.snackbar.open('Tidak bisa menemukan sheet bernama data', 'OK', {duration : 1000});
  //     }
  //   } else {
  //     this.snackbar.open('Tidak ada file yang dipilih atau file yang dipilih tidak sesuai', null, {duration : 2000});
  //   }
  //   // console.log(workbook.SheetNames);
  //   // const bl = new Blob(['pendopendo\n', 'cckkiimmaaii'], {type : 'text/plain;charset=utf-8'});
  // }

}



// WEBPACK FOOTER //
// ./src/app/faktur-pajak-keluaran/faktur-pajak-keluaran.component.ts